import { render, staticRenderFns } from "./SubscriptionAttendantDashboard.vue?vue&type=template&id=6fd47b7c"
import script from "./SubscriptionAttendantDashboard.vue?vue&type=script&lang=js"
export * from "./SubscriptionAttendantDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports